import { render, staticRenderFns } from "./VMapboxLegend.vue?vue&type=template&id=49c0eeb5"
import script from "./VMapboxLegend.vue?vue&type=script&lang=js"
export * from "./VMapboxLegend.vue?vue&type=script&lang=js"
import style0 from "./VMapboxLegend.vue?vue&type=style&index=0&id=49c0eeb5&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports